import React from "react";

import { Select, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import CustomCssTransition from "../../../components/UI/CustomCssTransition/customCssTransition";
import DispatchText from "../../../components/Jobs/dispatchText";

import "../CustomUrl.css";

const { Option } = Select;

const FieldLabel = ({ children, tooltip }) => (
  <label className="custom-url-field-label">
    {children}
    {tooltip && (
      <Tooltip title={tooltip}>
        <InfoCircleOutlined style={{ cursor: "pointer" }} />
      </Tooltip>
    )}
  </label>
);

const Step2Panel = ({
  customerType,
  setCustomerType,
  additionalInfo,
  setAdditionalInfo,
  isdispatchFee,
  setIsDispatchFee,
  dispatchDetails,
  handleDispatchTextChange,
  provider = "ST",
  showDispatchFee = true,
}) => {
  const isHCP = provider === "HCP";

  return (
    <div>
      <div className="custom-url-field-group">
        <FieldLabel tooltip="Restrict who can use this link.">
          Customer Type
        </FieldLabel>
        <Select
          placeholder="Select customer type"
          onChange={(value) => setCustomerType(value)}
          value={customerType}
          style={{ width: "100%", borderRadius: "8px" }}
        >
          <Option value="Existing Customer">Existing Customer</Option>
          <Option value="New Customer">New Customer</Option>
          <Option value="Both">Both</Option>
        </Select>
      </div>

      <div className="custom-url-field-group">
        <FieldLabel tooltip="Ask customers to describe their issue before booking.">
          Additional Info
        </FieldLabel>
        <Select
          placeholder="Select"
          onChange={setAdditionalInfo}
          style={{ width: "100%", borderRadius: "8px" }}
          value={additionalInfo}
        >
          <Option value={true}>Yes</Option>
          <Option value={false}>No</Option>
        </Select>
      </div>

      <CustomCssTransition
        in={showDispatchFee}
        timeout={300}
        classNames="glimpse"
        unmountOnExit
      >
        <div>
          <div className="custom-url-field-group">
            <FieldLabel tooltip="Display a fee agreement before customers book.">
              {isHCP ? "Service Fee" : "Dispatch Fee"}
            </FieldLabel>
            <Select
              placeholder={isHCP ? "Service Fee" : "Dispatch Fee"}
              onChange={(value) => setIsDispatchFee(value)}
              style={{ width: "100%", borderRadius: "8px" }}
              value={isdispatchFee}
            >
              <Option value={true}>Yes</Option>
              <Option value={false}>No</Option>
            </Select>
            <p className="custom-url-field-helper">
              Customers must agree to the fee before completing their booking.
            </p>
          </div>

          <CustomCssTransition
            in={isdispatchFee}
            timeout={300}
            classNames="glimpse"
            unmountOnExit
          >
            <div className="custom-url-field-group" style={{ boxSizing: "border-box" }}>
              <DispatchText
                member_dispatch_fee={isHCP ? 0 : dispatchDetails?.member_dispatch_fee}
                dispatch_fee={dispatchDetails.dispatch_fee}
                isDefault={false}
                dispatchVisibility={false}
                header={dispatchDetails.dispatch_header}
                body={dispatchDetails.dispatch_body}
                checkboxText={dispatchDetails.dispatch_text}
                onChange={handleDispatchTextChange}
                provider={provider}
              />
            </div>
          </CustomCssTransition>
        </div>
      </CustomCssTransition>
    </div>
  );
};

export default Step2Panel;
